import React, { useState, useEffect } from "react"
import axios from "axios"
import { BASE_URL } from "../../../Util/requests"
import Input from "../../../Components/Input"
import Questionnaire from "../../../Components/Questionnaire"
import SearchButtons from "../../../Components/SearchButtons"
import image_delete from "../../../Images/Buttons/cancel.png"
import image_loading from "../../../Images/spinner.gif"
import image_select from "../../../Images/Buttons/select_circle.png"

const SearchServiceNational = ({modeSearch, databaseType, databasePath, jsonLogin, jsonCompany, system, setAdd, setSelected, setReturn, showMenu,
  width}) => {

  const [selectedField, setSelectedField] = useState("")

  const [code, setCode] = useState("")
  const [description, setDescription] = useState("")

  const [showResult, setShowResult] = useState(false)

  const [result, setResult] = useState({})
  const [loading, setLoading] = useState(null)
  const [warning, setWarning] = useState("")
  const [error, setError] = useState("")
  const [errorImport, setErrorImport] = useState("")

  const [updatePage, setUpdatePage] = useState(0)
  
  const [askQuestionnaire, setAskQuestionnaire] = useState("")
  const [showQuestionnaire, setShowQuestionnaire] = useState(false)

  useEffect(() => {
    let returnJson = []
    let search = false

    let jServiceNational = "{ "
    if (code !== "") {
      if (String(code) !== "0") {
        jServiceNational += "\"CODE\": "+ code
        search = true
      } else setCode("")
    }
    if (description !== ""){
      if (description.length > 2){      
        if (jServiceNational !== "{ ") jServiceNational += ", "
        jServiceNational += "\"DESCRIPTION\": \""+ description + "\""
        search = true
      }
    }
    jServiceNational += " }"

    if (jServiceNational === "{  }") search = true

    if (search){
      setWarning("")
      setError("")      
      setLoading("Aguarde buscando as informações...")

      let formData = new FormData()
      formData.append("DATABASE_TYPE", databaseType)
      formData.append("DATABASE_PATH", databasePath)
      formData.append("JSON_NEW_1", jServiceNational)
      formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
      formData.append("SYSTEM", system)

      axios.post(BASE_URL + "SERVICE_CODE_NATIONAL/Search", formData)
      .then((response) => { returnJson = JSON.parse(response.data) })
      .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
        ", \"ERROR\": \"Não foi possível pesquisar os serviços nacionais. ("+ response +")\"}") })
      .finally(() => {
        if (returnJson.SUCCESS === false){
          setError(returnJson.ERROR)
          setShowResult(false)
          setLoading("")

          if (selectedField === "searchServiceNationalDescription") 
            document.getElementById("searchServiceNationalDescription") && document.getElementById("searchServiceNationalDescription").focus()
          else document.getElementById("searchServiceNationalCode") && document.getElementById("searchServiceNationalCode").focus()
        
          return
        }

        setResult(returnJson)
        setShowResult(true)
        setLoading("")

        if (selectedField === "searchServiceNationalDescription") 
          document.getElementById("searchServiceNationalDescription") && document.getElementById("searchServiceNationalDescription").focus()
        else document.getElementById("searchServiceNationalCode") && document.getElementById("searchServiceNationalCode").focus()
      })
    }
    else {
      setLoading("")
      setWarning("")
      setError("")
      setShowResult(false)

      if (selectedField === "searchServiceNationalDescription") 
        document.getElementById("searchServiceNationalDescription") && document.getElementById("searchServiceNationalDescription").focus()
      else document.getElementById("searchServiceNationalCode") && document.getElementById("searchServiceNationalCode").focus()
    }
  }, [databaseType, databasePath, jsonLogin, system, code, description, updatePage])

  const callDelete = (item) => {
    setCode(item.CODE)
    setAskQuestionnaire("Deseja realmente excluir o serviço nacional (" + item.DESCRIPTION + ") ?")
    setShowQuestionnaire(true)
  }

  const cancelDelete = () => {
    setShowQuestionnaire(false)
    setCode(0)
  }

  const clean = () => {
    setCode("")
    setDescription("")

    setErrorImport("")
    setUpdatePage(updatePage + 1)
  }

  const confirmDelete = () => {
    let returnJson = []
    const jServiceCnae = "{ \"CODE\": \""+ code +"\" }"

    setLoading("Aguarde excluido o registro...")
    setWarning("")
    setError("")

    const formData = new FormData()
    formData.append("DATABASE_TYPE", databaseType)
    formData.append("DATABASE_PATH", databasePath)
    formData.append("JSON_NEW_1", jServiceCnae)
    formData.append("JSON_COMPANY", JSON.stringify(jsonCompany))
    formData.append("JSON_LOGIN", JSON.stringify(jsonLogin))
    formData.append("SYSTEM", system)

    axios.post(BASE_URL + "SERVICE_CODE_NATIONAL/Delete", formData)
    .then((response) => { returnJson = JSON.parse(response.data) })
    .catch((response) => { returnJson = JSON.parse("{ \"SUCCESS\": false, \"OBJECT\": null, \"AUDIT_CONFIGURATION\": null, \"WARNING\": null"+
      ", \"ERROR\": \"Não foi possível excluir o serviço nacional. ("+ response +")\"}") })
    .finally(() => {
      if (returnJson.SUCCESS === false){
        setError(returnJson.ERROR)
        setShowQuestionnaire(false)
        setCode(0)
        setLoading("")

        document.getElementById("searchServiceNationalCode") && document.getElementById("searchServiceNationalCode").focus()
        return
      }

      returnJson.WARNING && setWarning(returnJson.WARNING)

      setShowQuestionnaire(false)
      setCode(0)
      setLoading("")

      setUpdatePage(updatePage + 1)
    })
  }

  return(
    <div style={{display: "flex", flexDirection: "column", flexGrow: 1, paddingLeft: 10, paddingRight: 10}}>
      { loading ?
          <div style={{display: "flex", flexDirection: "column", flexGrow: 1, justifyContent: "center", alignItems : "center"}}>
            <img style={{marginBottom: 10, width: 28, height: 28}} src={image_loading} alt="Carregando"/>
            <label style={{fontWeight: 600, color: "rgb(0, 177, 171)", marginTop: 15}}>{loading}</label>
          </div>
        :
          <div style={{display: "flex", flexDirection: "column", flexGrow: 1}}>
            { showQuestionnaire ?
                <Questionnaire
                  ask={askQuestionnaire}
                  setConfirm={() => confirmDelete()}
                  setCancel={() => cancelDelete()} />
              :
                <>
                  <SearchButtons modeSearch={modeSearch} jsonCompany={jsonCompany} setAdd={() => setAdd()} clean={clean}
                    getSGE={() => console.log()} setReturn={setReturn} />

                  <div style={{display: "flex", justifyContent: "center", alignItems: "center"}}>
                    <div style={{display: "flex", flexGrow: 1, backgroundColor: "rgb(0, 177, 171)", marginTop: 8, height: 10}} />
                  </div>

                  <div style={{paddingLeft: 10, paddingRight: 10}}>
                    { warning &&
                      <div style={{display: "flex", flexGrow: 0, justifyContent: "center", marginTop: 10, marginBottom: 10}}>
                        <label style={{fontWeight: 600, color: "rgb(0, 177, 171)"}}>{warning}</label>
                      </div> 
                    }

                    { error &&
                      <div style={{display: "flex", flexGrow: 0, justifyContent: "center", marginTop: 10, marginBottom: 10}}>
                        <label style={{fontWeight: 600, color: "red"}}>{error}</label>
                      </div> 
                    }

                    { errorImport &&
                      <div style={{display: "flex", flexGrow: 0, justifyContent: "center", marginTop: 10, marginBottom: 10}}>
                        <label style={{fontWeight: 600, color: "red"}}>{errorImport}</label>
                      </div>
                    }

                    <div style={{paddingLeft: 10, paddingRight: 10}}>
                      <div style={{display: "flex", justifyContent: "center", alignItems: "center", marginTop: 10, marginRight: 0,
                        marginBottom: 10, marginLeft: 0}}>
                        <label style={{fontWeight: 600, textAlign: "center"}}>CRITÉRIOS PARA PESQUISA</label>
                      </div>

                      <div style={(showMenu) ?
                          (width < 640) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                          : (width < 690) ? {display: "flex", flexDirection: "row", flexGrow: 0}
                          : (width < 890) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                          : {display: "flex", flexDirection: "row", flexGrow: 0}
                        :
                          (width < 690) ? {display: "flex", flexDirection: "column", flexGrow: 0}
                          : {display: "flex", flexDirection: "row", flexGrow: 0}}>
                        <div style={(showMenu) ?
                            (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : (width < 690) ? {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}
                            : (width < 890) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}
                          : 
                            (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180}
                            : {display: "flex", flexGrow: 0, minWidth: 160, maxWidth: 160}}>
                          <Input
                            type="search"
                            name="searchServiceNationalCode"
                            description="Código"
                            value={code}
                            maxLength={6}
                            disabled={false}
                            require={false}
                            image={false}
                            typeInput={2}
                            onSelect={setSelectedField}
                            onChange={(event) => setCode(event.target.value)} />
                        </div>
                        <div style={(showMenu) ?
                            (width < 640) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                            : (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                            : (width < 890) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                            : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}
                          : 
                            (width < 690) ? {display: "flex", flexGrow: 1, minWidth: 180, marginTop: 10}
                            : {display: "flex", flexGrow: 1, minWidth: 180, marginLeft: 10}}>
                          <Input
                            type="search"
                            name="searchServiceNationalDescription"
                            description="Descrição"
                            value={description}
                            //maxLength={80}
                            disabled={false}
                            require={false}
                            image={false}
                            typeInput={2}
                            onSelect={setSelectedField}
                            onChange={(event) => setDescription(event.target.value)} />
                        </div>
                      </div>

                      { showResult && 
                        <>
                          { result.OBJECT &&
                            <>
                              <div style={{display: "flex", flexDirection: "row", flexGrow: 1, borderBottomColor: "black",
                                borderBottomWidth: 2, borderBottomStyle: "solid", marginTop: 30, marginBottom: 4, marginLeft: 5,
                                minWidth: 180}}>

                                <div style={(showMenu) ?
                                    (width < 860) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 8}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 8}
                                  :
                                    (width < 660) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 8}
                                    : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 8}}>                                        

                                  <div style={(showMenu) ?
                                      (width < 860) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, alignItems: "center", minWidth: 100, maxWidth: 100}
                                    :
                                      (width < 660) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                      : {display: "flex", flexGrow: 0, minWidth: 100, maxWidth: 100}}>
                                    <label style={{fontWeight: 600}}>Código</label>
                                  </div>
                                  <div style={{display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}}>
                                    <label style={{fontWeight: 600}}>Descrição</label>
                                  </div>
                                </div>

                                { (width >= 450) &&
                                  <div style={{display: "flex", flexGrow: 0, marginRight: 7}}>
                                    <div style={{height: 32, width: 32}} />
                                    { !modeSearch && <div style={{marginTop: 2, marginLeft: 10, height: 28, width: 28}} /> }
                                  </div>
                                }
                              </div>

                              { result.OBJECT.map(item => (
                                <div key={item.CODE} style={(width < 450) ? {display: "flex", flexDirection: "column", flexGrow: 1,
                                  backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5,
                                  borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingRight: 8, paddingBottom: 8,
                                  marginTop: 4, minWidth: 180} 
                                  : {display: "flex", flexDirection: "row", flexGrow: 1, alignItems: "center",
                                  backgroundColor: "rgb(241, 242, 242)", borderLeftStyle: "solid", borderLeftWidth: 5,
                                  borderLeftColor: "rgb(0, 177, 171)", borderRadius: 5, paddingTop: 8, paddingBottom: 8, paddingRight: 8,
                                  marginTop: 4, minWidth: 180}}>

                                  <div style={(showMenu) ?
                                      (width < 860) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}
                                    :
                                      (width < 660) ? {display: "flex", flexDirection: "column", flexGrow: 1, marginLeft: 10}
                                      : {display: "flex", flexDirection: "row", flexGrow: 1, marginLeft: 10}}>                                        

                                    <div style={(showMenu) ?
                                        (width < 860) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, alignItems: "center", minWidth: 100, maxWidth: 100}
                                      :
                                        (width < 660) ? {display: "flex", flexGrow: 1, minWidth: 180}
                                        : {display: "flex", flexGrow: 0, alignItems: "center", minWidth: 100, maxWidth: 100}}>
                                      <label>{item.CODE}</label>
                                    </div>
                                    <div style={{display: "flex", flexDirection: "row", flexGrow: 1, minWidth: 180}}>
                                      <label>{item.DESCRIPTION}</label>
                                    </div>
                                  </div>
                                  <div style={(width < 450) ? {display: "flex", flexGrow: 1, justifyContent: "center", marginTop: 10}
                                    : {display: "flex", flexGrow: 0}}>

                                    <img
                                      style={{height: 32, width: 32}}
                                      src={image_select}
                                      name="searchServiceNationalSelect"
                                      alt="Selecionar"
                                      onClick={() => setSelected(item)} />

                                    { !modeSearch && 
                                      <img
                                        style={{height: 28, width: 28, marginTop: 2, marginLeft: 10}}
                                        src={image_delete}
                                        name="searchServiceNationalDelete"
                                        alt="Deletar"
                                        onClick={() => callDelete(item)} />
                                    }
                                  </div>
                                </div>
                                ))
                              }
                            </>
                          }
                        </>
                      }
                    </div>
                  </div>
                </>
            }
          </div>
      }
    </div>
  )
}

export default SearchServiceNational